import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'
import {TasksQueryKey} from '../useTasks'

import {ProcessWorkOrderQueryKey} from './useProcessWorkOrder'

interface DeleteWorkOrderParams {
  plantId: string
  externalId: string
}
const INTERVAL = 400
const REPEATS = 5

export const useDeleteProcessWorkOrder = () => {
  const queryClient = useQueryClient()

  return useMutation<boolean, AxiosError, DeleteWorkOrderParams>({
    mutationFn: async ({plantId, externalId}) => {
      const path = `${TasksApiPath.PROCESS_WORK_ORDERS}/${plantId}/process-work-orders/${externalId}`
      const {data} = await ApiClient.axiosInstance.delete<{data: boolean}>(path)
      return data.data
    },

    onSuccess: async (_, {plantId, externalId}) => {
      void queryClient.invalidateQueries({
        queryKey: [ProcessWorkOrderQueryKey, externalId, plantId]
      })
      void queryClient.invalidateQueries({
        queryKey: [TasksQueryKey, plantId]
      })
      for (let i = 0; i < REPEATS; i++) {
        await queryClient.invalidateQueries({queryKey: [TasksQueryKey]})
        await new Promise((resolve) => setTimeout(resolve, INTERVAL))
      }
    }
  })
}
